export class Armccm {

    companyName: string;
    contactName: string;
    phoneNumber: string;
    emailAddress: string;
    reportingMonth: string;
    reportingYear: number;
    reportingPeriodMonth: string;
    reportingPeriodYear: number;
    serviceRevenueRetail: string;
    uncollectibleRevenues: string;
    telecommunicationsRetail: string;
    contributionAmount: string;
    contributionPercentage: number;
    previousCompanyName: string;
    explanation: string;
}
